"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * [[SignalingClientVideoSubscriptionConfiguration]] is an internal representation of
 * `SignalingProtocol.videoSubscriptionConfiguration`
 */
class SignalingClientVideoSubscriptionConfiguration {
    equals(other) {
        return (other !== undefined &&
            this.mid === other.mid &&
            this.attendeeId === other.attendeeId &&
            this.streamId === other.streamId &&
            this.groupId === other.groupId &&
            this.priority === other.priority &&
            this.targetBitrateKbps === other.targetBitrateKbps &&
            this.qualityAdaptationPreference === other.qualityAdaptationPreference);
    }
}
exports.default = SignalingClientVideoSubscriptionConfiguration;
//# sourceMappingURL=SignalingClientVideoSubscriptionConfiguration.js.map